import { render, staticRenderFns } from "./gc-status-chip.vue?vue&type=template&id=3c7ed2ae&scoped=true&"
import script from "./gc-status-chip.vue?vue&type=script&lang=js&"
export * from "./gc-status-chip.vue?vue&type=script&lang=js&"
import style0 from "./gc-status-chip.vue?vue&type=style&index=0&id=3c7ed2ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7ed2ae",
  null
  
)

export default component.exports